(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function initTimers() {
      document.querySelectorAll('[data-flash-timer]').forEach(function (el) {
        if (el.dataset.flashTimerInit) return;
        el.dataset.flashTimerInit = '1';
        startTimer(el);
      });
    }

    function startTimer(el) {
      var endStr = el.dataset.end;
      if (!endStr) return;

      var endTime = new Date(endStr).getTime();
      if (isNaN(endTime)) return;

      var hoursEl   = el.querySelector('[data-fst-hours]');
      var minutesEl = el.querySelector('[data-fst-minutes]');
      var secondsEl = el.querySelector('[data-fst-seconds]');

      if (!hoursEl || !minutesEl || !secondsEl) return;

      function tick() {
        var remaining = endTime - Date.now();

        if (remaining <= 0) {
          el.innerHTML = '<p class="flash-countdown__ended">' + (el.dataset.endedText || 'Sale has ended.') + '</p>';
          return;
        }

        var h = Math.floor(remaining / 3600000);
        var m = Math.floor((remaining % 3600000) / 60000);
        var s = Math.floor((remaining % 60000) / 1000);

        hoursEl.textContent   = String(h).padStart(2, '0');
        minutesEl.textContent = String(m).padStart(2, '0');
        secondsEl.textContent = String(s).padStart(2, '0');

        setTimeout(tick, 1000);
      }

      tick();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTimers);
    } else {
      initTimers();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
